import { LoginRouteType, RouteRecordRaw } from 'vue-router';

import { getQueryString } from '@/utils/redirectToLoginPage';
import LoginView from '@/views/login/LoginView.vue';
import NativeLoginSocialView from '@/views/login/NativeLoginSocialView.vue';
import NativeLoginUserSubView from '@/views/login/NativeLoginUserSubView.vue';
import SelfServiceLoginView from '@/views/login/SelfServiceLoginView.vue';

const loginTypeMapping: Record<LoginRouteType, string> = {
  admin: 'customer',
  dist: 'dist',
} as const;

export default function loginRoutes(): RouteRecordRaw[] {
  return [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      beforeEnter: (to, from, next) => {
        const { type: loginType, ...restQuery } = to.query;

        if (typeof loginType !== 'string' || !loginTypeMapping[loginType]) {
          return next();
        }

        if (restQuery['redirectTo']) {
          const queryString = getQueryString(restQuery);
          return next(`/login?${queryString}`);
        }

        window.location.href = `${window.location.origin}/admin/login/${loginTypeMapping[loginType]}`;

        return false;
      },
    },
    // 셀프서비스 로그인
    {
      path: '/login/ss',
      name: 'login-ss',
      component: SelfServiceLoginView,
    },
    // 셀프서비스 추가사용자 로그인
    {
      path: '/login/ss/sub',
      name: 'login-ss-sub',
      component: SelfServiceLoginView,
    },
    // 앱 로그인
    {
      path: '/app/login',
      name: 'native-login',
      component: NativeLoginSocialView,
    },
    {
      path: '/app/adduse',
      name: 'native-adduse',
      component: NativeLoginUserSubView,
    },
    {
      path: '/login/:type/:partnerCode',
      name: 'login-partnerCode',
      redirect: (to) => ({
        path: '/login',
        query: { type: to.params.type, partnerCode: to.params.partnerCode },
      }),
    },
    {
      path: '/login/:type',
      name: 'login-type',
      redirect: (to) => ({ path: '/login', query: { type: to.params.type } }),
    },
    // TODO: 추후 '/login/:type' 으로 통합시, '/admin-login', '/dist/login', '/internal/login' 삭제
    {
      path: '/admin-login',
      name: 'admin-login',
      redirect: () => ({ path: '/login', query: { type: 'admin' } }),
    },
    {
      path: '/dist/login',
      name: 'dist-login',
      redirect: () => ({ path: '/login', query: { type: 'dist' } }),
    },
    {
      path: '/internal/login',
      name: 'internal-login',
      redirect: () => ({ path: '/login', query: { type: 'internal' } }),
    },
  ];
}
